/**
 * 返回表头数据
 * @param {*} flag  0 教务处报名信息  1 成绩  2 录取
 */
export function returnMenu(flag) {
    let menu = []
    switch (flag) {
        case 0:
            menu = [
                { key: 'testNum', title: "考生号", width: 180 },
                { key: 'name', title: "姓名", width: 220 },
                { key: 'idCard', title: "身份证号码", width: 220 },
                { key: 'readyProfession', title: "报考专业", },
            ]
            break;
        case 1:
            menu = [
                { key: 'name', title: "姓名", width: 80 },
                { key: 'admissionNum', title: "准考证号", width: 180 },
                { key: 'idCard', title: "身份证号码", width: 180 },
                { key: 'readyProfession', title: "报考专业", width: 220 },
                { key: 'testRoom', title: "考场号", width: 110 },
                { key: 'theoryNum', title: "专业课科目一", width: 180 },
                { key: 'skillNum', title: "专业课科目二", width: 180 },
                { key: 'scoreRemark', title: "备注" },
            ]
            break;
        case 2:
            menu = [
                { key: 'testNum', title: "考生号", width: 220 },
                { key: 'name', title: "姓名", width: 120 },
                { key: 'idCard', title: "身份证号码", width: 180 },
                { key: 'readyProfession', title: "录取专业", width: 220 },
                { key: 'enrollRemark', title: "备注", },
            ]
            break;
        case 3:
            menu = [
                { key: 'name', title: "姓名", width: 120 },
                { key: 'gender', title: "性别", width: 120 },
                { key: 'examineeNumber', title: "考生号", width: 120 },
                { key: 'idNumber', title: "身份证号码", width: 120 },
                { key: 'admitNumber', title: "准考证号", width: 120 },
                { key: 'choiceSchool', title: "志愿学校", width: 120 },
                { key: 'choiceMajor', title: "志愿专业", width: 120 },
                { key: 'siteName', title: "考点名称", width: 120 },
                { key: 'siteAddress', title: "考点地址", width: 120 },
                { key: 'subjectOne', title: "科目一", width: 120 },
                { key: 'subjectOneRoomNumber', title: "考场号", width: 120 },
                { key: 'subjectOneSeatNumber', title: "座位号", width: 120 },
                { key: 'subjectOneTime', title: "考试时间", width: 120 },
                { key: 'subjectTwo', title: "科目二", width: 120 },
                { key: 'subjectTwoRoomNumber', title: "考场号", width: 120 },
                { key: 'subjectTwoSeatNumber', title: "座位号", width: 120 },
                { key: 'subjectTwoTime', title: "考试时间", width: 120 },
            ]
            break;
        case 8:
            menu = [
                { key: 'examNumber', title: "考生号", width: 220 },
                { key: 'idNumber', title: "身份证号码", width: 220 },
                { key: 'name', title: "姓名", width: 220 },
                { key: 'year', title: "录取年份", width: 120 },
                { key: 'major', title: "拟录取专业", width: "" },
            ]
            break;

        default:
            break;
    }
    return menu
}

/**
 * 返回搜索条目
 * @param {*} options 录取专业
 */
export function returnSearchData(options) {
    let dateY = new Date().getFullYear().toString()
    return [
        { title: "姓名/身份证号", value: "", type: "input", key: "search" },
        { title: "录取专业", value: "", type: "select", options: options, key: "readyProfession" },
        { title: "年份", value: dateY, type: "time_year", key: "year" },
    ]
}

/**
 * 返回界面需要的按钮
 * @param {*} flag  0 为教务处报名信息,比1,2多一个清空
 */
export function returnButData(flag) {
    let but = []
    switch (flag) {
        case 0:
            but = [
                { title: "清空报名", active: "clean", icon: 'el-icon-delete' },
                {
                    title: "导入", active: "export", flag: 3, icon: "el-icon-upload2", uploadTitle: "导入教务处信息",
                    url: "/registration/importTrue"
                },
                { title: "模板下载", active: "model", icon: 'el-icon-download' },
            ]
            break;
        case 1:
            but = [
                {
                    title: "导入", active: "export", flag: 4, icon: "el-icon-upload2", uploadTitle: "导入学生成绩",
                    url: "/registration/importScore"
                },
                { title: "模板下载", active: "model", icon: 'el-icon-download' },
            ]

            break
        case 2:
            but = [
                {
                    title: "导入", active: "chooseExport", flag: 5, icon: "el-icon-upload2", uploadTitle: "导入录取信息",
                    url: "/registration/importEnroll"
                },
                { title: "模板下载", active: "model", icon: 'el-icon-download' },
            ]
            break
        case 3:
            but = [
                {
                    title: "导入照片", active: "export", flag: 5, icon: "el-icon-upload2", uploadTitle: "导入照片",
                    url: "/admit/uploadAdmitImagesZip"
                },
                {
                    title: "导入", active: "export", flag: 5, icon: "el-icon-upload2", uploadTitle: "导入准考证信息",
                    url: "/admit/importAdmit"
                },
                { title: "模板下载", active: "model", icon: 'el-icon-download' },
            ]
            break
        case 8:
            but = [
                {
                    title: "本科录取导入", active: "export", flag: 3, icon: "el-icon-upload2", uploadTitle: "导入教务处信息",
                    url: "/bachelor/importBachelor"
                },
            ]
        default:
            break;
    }
    return but
}

/**
 * 返回初始化表格的接口
 * @param {*} flag   0 查询教务处报名信息  1 查询成绩  2 查询录取  3 准考证查询
 *                   4 导入教务处报名信息  5 导入成绩  6 导入录取  7 导入准考证
 */
export function returnInitUrl(flag) {
    let url = ""
    switch (flag) {
        case 0:
            url = "/registration/getTrueList"
            break;
        case 1:
            url = "/registration/getScoreList"
            break;
        case 2:
            url = "/registration/getEnrollList"
            break;
        case 3:
            url = "/admit/getAdmitListByPage"
            break;
        case 4:
            url = "/registration/importTrue"
            break;
        case 5:
            url = "/registration/importScore"
            break;
        case 6:
            url = "/registration/importEnroll"
            break;
        case 7:
            url = "/admit/importAdmit"
            break;
        case 8:
            url = "/registration/getQueryEnrollList"
            break;

        default:
            break;
    }
    return url
}
